import { Label } from 'cpool-components/general/Label';
import { SegmentedControl } from 'cpool-components/input/SegmentedControl';
import type { SegmentedControlOption } from 'cpool-components/input/SegmentedControl/types';
import type { Control, FieldValues, Path } from 'react-hook-form';

import { FormField } from './FormField';
import { formatFormLabel } from '../formatFormLabel';

type FormSegmentedControlProps<TFieldValues extends FieldValues, TValue extends string> = {
    control: Control<TFieldValues>;
    disabled?: boolean;
    id: Path<TFieldValues>;
    label: string;
    options: SegmentedControlOption<TValue>[];
    required?: boolean;
};

export const FormSegmentedControl = <TFieldValues extends FieldValues, TValue extends string>({
    control,
    disabled,
    id,
    label,
    options,
    required,
}: FormSegmentedControlProps<TFieldValues, TValue>) => (
    <FormField<TFieldValues, TValue | null> control={control} name={id}>
        {({ error, onChange, value }) => (
            <div className="flex items-start gap-2.5">
                <Label className="h-8 w-[175px] shrink-0 justify-start">
                    {formatFormLabel(label, required)}
                </Label>
                <SegmentedControl<TValue>
                    id={id}
                    ariaLabel={label}
                    options={options}
                    value={value ?? null}
                    onChange={onChange}
                    disabled={disabled}
                    error={error}
                />
            </div>
        )}
    </FormField>
);
